export function getBaseUrl(explicit?: string): string {
  if (explicit) return explicit.replace(/\/$/, "");
  const c = (globalThis as { DWTF_CONFIG?: { customDomain?: string; apiUrl?: string } }).DWTF_CONFIG;
  if (c?.apiUrl) return c.apiUrl.replace(/\/$/, "");
  if (c?.customDomain) return `https://${c.customDomain}`;
  if (typeof document !== "undefined") {
    const s = document.currentScript as HTMLScriptElement | null;
    if (s?.src) {
      try {
        return new URL(s.src).origin;
      } catch {
        /* */
      }
    }
  }
  return "https://api.d.wtf";
}
